import React, { useState } from "react";
import { Table, Tag, Typography, Empty } from "antd";
import { fetchLeadImportHistoryRowsApi } from "../../../../apiservice/crm";

const { Text } = Typography;

const outcomeTag = (outcome) => {
  if (outcome === "imported") return <Tag color="green">Imported</Tag>;
  if (outcome === "duplicate") return <Tag color="orange">Duplicate</Tag>;
  return <Tag color="red">Error</Tag>;
};

const LeadImportHistory = ({ runs = [], loading }) => {
  const [rowsByRun, setRowsByRun] = useState({});
  const [expandLoading, setExpandLoading] = useState({});

  const onExpand = async (expanded, run) => {
    if (!expanded || rowsByRun[run.id]) return;
    setExpandLoading((s) => ({ ...s, [run.id]: true }));
    try {
      const res = await fetchLeadImportHistoryRowsApi(run.id);
      setRowsByRun((s) => ({ ...s, [run.id]: res.data?.rows || [] }));
    } catch (err) {
      setRowsByRun((s) => ({ ...s, [run.id]: [] }));
    } finally {
      setExpandLoading((s) => ({ ...s, [run.id]: false }));
    }
  };

  const columns = [
    { title: "File", dataIndex: "file_name", render: (v) => v || "-" },
    { title: "Imported By", dataIndex: "imported_by_name", render: (v) => v || "-" },
    { title: "When", dataIndex: "created_at", render: (v) => (v ? new Date(v).toLocaleString() : "-") },
    { title: "Rows", dataIndex: "total_rows", width: 80 },
    {
      title: "Imported",
      dataIndex: "imported_count",
      width: 100,
      render: (v) => <Text type="success">{v}</Text>,
    },
    {
      title: "Duplicates",
      dataIndex: "duplicate_count",
      width: 100,
      render: (v) => (v > 0 ? <Text type="warning">{v}</Text> : v),
    },
    {
      title: "Errors",
      dataIndex: "error_count",
      width: 90,
      render: (v) => (v > 0 ? <Text type="danger">{v}</Text> : v),
    },
  ];

  const detailColumns = [
    { title: "Row", dataIndex: "row_no", width: 60 },
    { title: "Name", dataIndex: "name", render: (v) => v || "-" },
    { title: "Phone", dataIndex: "phone", render: (v) => v || "-" },
    { title: "Status", dataIndex: "status_name", render: (v) => v || "-" },
    { title: "Outcome", dataIndex: "outcome", width: 110, render: outcomeTag },
    { title: "Detail", dataIndex: "message", render: (v) => v || "-" },
  ];

  return (
    <Table
      rowKey="id"
      dataSource={runs}
      loading={loading}
      columns={columns}
      locale={{ emptyText: <Empty description="No leads have been imported yet" /> }}
      expandable={{
        onExpand,
        expandedRowRender: (run) => (
          <Table
            size="small"
            rowKey="row_no"
            loading={Boolean(expandLoading[run.id])}
            dataSource={rowsByRun[run.id] || []}
            columns={detailColumns}
            pagination={{ pageSize: 20, showSizeChanger: false }}
          />
        ),
      }}
      pagination={{ pageSize: 10, showSizeChanger: false }}
    />
  );
};

export default LeadImportHistory;
